export const GET_MASTERPONDOK_REQUEST = "masterpondok/get/request";
export const GET_MASTERPONDOK_SUCCEED = "masterpondok/get/succeed";
export const GET_MASTERPONDOK_FAILED = "masterpondok/get/failed";

export const GET_BY_ID_MASTERPONDOK_REQUEST = "masterpondok/getid/request";
export const GET_BY_ID_MASTERPONDOK_SUCCEED = "masterpondok/getid/succeed";
export const GET_BY_ID_MASTERPONDOK_FAILED = "masterpondok/getid/failed";

export const GET_BY_MASTERPONDOK_REQUEST =
  "masterpondok/getmasterpondok/succeed";
export const GET_BY_MASTERPONDOK_SUCCEED =
  "masterpondok/getmasterpondok/request";
export const GET_BY_MASTERPONDOK_FAILED = "masterpondok/getmasterpondok/failed";

export const CREATE_MASTERPONDOK_REQUEST = "masterpondok/create/request";
export const CREATE_MASTERPONDOK_SUCCEED = "masterpondok/create/succeed";
export const CREATE_MASTERPONDOK_FAILED = "masterpondok/create/failed";

export const DELETE_MASTERPONDOK_REQUEST = "masterpondok/delete/request";
export const DELETE_MASTERPONDOK_SUCCEED = "masterpondok/delete/succeed";
export const DELETE_MASTERPONDOK_FAILED = "masterpondok/delete/failed";

export const UPDATE_MASTERPONDOK_REQUEST = "masterpondok/update/request";
export const UPDATE_MASTERPONDOK_SUCCEED = "masterpondok/update/succeed";
export const UPDATE_MASTERPONDOK_FAILED = "masterpondok/update/failed";

export const UPDATE_MASTERPONDOK_NOFILE_REQUEST =
  "masterpondok/updatenofile/request";
export const UPDATE_MASTERPONDOK_NOFILE_SUCCEED =
  "masterpondok/updatenofile/succeed";
export const UPDATE_MASTERPONDOK_NOFILE_FAILED =
  "masterpondok/updatenofile/failed";
